import {
  EmailFlowData,
  ResponseItem,
  ResponseData,
  ContactTypes,
  EmailFlowAction,
  EmailFlowActionTypes,
} from "./types";

export const initialState: EmailFlowData = {
  emailsList: [],
  phonesList: [],
  lastUsed: "",
  contactValue: "",
  sourceList: {},
  primaryEmail: "",
  verifyPinError: false,
  isLoading: false,
};
const emailFlowReducer = (
  state = initialState,
  { type, payload }: EmailFlowAction
) => {
  switch (type) {
    case EmailFlowActionTypes.SET_EMAILS_FOR_EMAIL_FLOW:
      const reducedPayload = payload.reduce(
        (acc: ResponseData, item: ResponseItem) => {
          if (!item.hasMask && item.type === ContactTypes.EMAIL) {
            acc.primaryEmail = item.value;
          }
          if (item.isLastUsed) {
            acc.lastUsed = item.value;
          }
          if (item.type === ContactTypes.EMAIL) {
            acc.emailsList.push({
              id: item.id,
              value: item.value,
              lockdownInSeconds: item.lockdownInSeconds,
            });
          }
          if (item.type === ContactTypes.PHONE) {
            acc.phonesList.push({
              id: item.id,
              value: item.value,
              lockdownInSeconds: item.lockdownInSeconds,
            });
          }
          return acc;
        },
        {
          emailsList: [],
          phonesList: [],
          lastUsed: "",
          primaryEmail: "",
        }
      );

      return {
        ...state,
        ...reducedPayload,
      };
    case EmailFlowActionTypes.SET_PIN_CHECK_ERROR_FOR_EMAIL_FLOW:
      return {
        ...state,
        verifyPinError: true,
      };
    case EmailFlowActionTypes.GET_EMAILS_FOR_EMAIL_FLOW:
      return {
        ...state,
        verifyPinError: false,
      };
    case EmailFlowActionTypes.RESET_PIN_CHECK_ERROR_FOR_EMAIL_FLOW:
      return {
        ...state,
        verifyPinError: false,
      };
    case EmailFlowActionTypes.GET_SOURCES:
      return {
        ...state,
        contactValue: "",
        sourceList: {},
      };
    case EmailFlowActionTypes.SET_SOURCES:
      return {
        ...state,
        contactValue: payload.contactValue,
        sourceList: { ...payload.sources },
      };
    case EmailFlowActionTypes.SET_BTN_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case EmailFlowActionTypes.CLEAN_BTN_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
export default emailFlowReducer;
